import {
    DevelopmentDetailsQuery,
    Listing
} from '@zoopla/listing-search-queries';

export const mapDevelopmentDetailsToListings = (
    data: DevelopmentDetailsQuery | undefined
): Partial<Listing & { description: string }>[] => {
    if (!data?.newHomesDevelopmentData?.listingsDetails?.listings) {
        return [];
    }

    const listings = data.newHomesDevelopmentData.listingsDetails.listings;
    const images = data.newHomesDevelopmentData?.images;

    const descriptions: { [key: string]: string } = {
        detached: 'Detached house',
        end_terrace: 'Terraced house',
        flat: 'Flat',
        semi_detached: 'Semi-detached house',
        terraced: 'Terraced house'
    };

    return listings.map((listing) => {
        const description = listing?.propertyType
            ? descriptions[listing?.propertyType]
            : '';

        const listingId = listing?.listingId ?? '';

        return {
            image: {
                src: images?.[0] ?? null
            },
            price: listing?.pricing.label,
            features: [
                { content: listing?.counts.numBedrooms, iconId: 'bed' },
                {
                    content: listing?.counts.numBathrooms,
                    iconId: 'bath'
                },
                {
                    content: listing?.counts.numLivingRooms,
                    iconId: 'chair'
                }
            ],
            description: `${
                description ? `${description} for sale` : 'For sale'
            }`,
            listingUris: {
                detail: `/new-homes/details/${listingId}`
            },
            listingId: listingId
        };
    });
};
